import { render, staticRenderFns } from "./StalePositions.vue?vue&type=template&id=2e1fe3b4&scoped=true"
import script from "./StalePositions.vue?vue&type=script&lang=js"
export * from "./StalePositions.vue?vue&type=script&lang=js"
import style0 from "./StalePositions.vue?vue&type=style&index=0&id=2e1fe3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1fe3b4",
  null
  
)

export default component.exports